import jwt_decode from "jwt-decode";


export const state = {
  user: {},
  accessToken: localStorage.getItem("token"),
  isAuthenticate: !!localStorage.getItem("token")
};

export const mutations = {
  setToken(state, payload) {
    state.accessToken = payload
    state.isAuthenticate = true
    localStorage.setItem('token', payload)
  },
  setGovUser(state, payload) {
    state.user = payload
  },
  setLogout(state) {
    state.isAuthenticate = false
    state.user = {}
    state.accessToken = null
    localStorage.removeItem('token')
  }
};

export const actions = {
  loginSuccess({ commit }, payload) {
    commit('setToken', payload.access_token)
    const userData = jwt_decode(state.accessToken);
    commit('setGovUser', {
      name: userData.user_metadata.name,
      surname: userData.user_metadata.surname,
      dept_name: userData.user_metadata.dept_name,
      dept_sub_name: userData.user_metadata.dept_sub_name
    })
  },
  logout({ commit }) {
    commit('setLogout')
  },
  setUserFromToken({ commit, state }) {
    if (!state.accessToken) return false

    try {
      const userData = jwt_decode(state.accessToken)
      if (userData.exp * 1000 < Date.now()) {
        commit('setLogout')
        return false
      }

      commit('setGovUser', {
        name: userData.user_metadata.name,
        surname: userData.user_metadata.surname,
        dept_name: userData.user_metadata.dept_name,
        dept_sub_name: userData.user_metadata.dept_sub_name
      })
      return true
    } catch (e) {
      commit('setLogout')
      return false
    }
  }
};

export const getters = {
  getToken: state => state.accessToken,
  isAuthenticate: state => state.isAuthenticate,
  getGovUserData: state => state.user
};
